import type { AdminStatsFilters, AdminStatsResponse } from 'types/admin-stats';

import { apiClient } from 'utils/api';

const serializeFilters = (filters: AdminStatsFilters) => {
  const params = new URLSearchParams();

  if (filters.startDate) params.append('startDate', filters.startDate.toISOString());
  if (filters.endDate) params.append('endDate', filters.endDate.toISOString());
  filters.campaignStatuses?.forEach((status) => params.append('campaignStatuses[]', status));
  filters.agentIds?.forEach((id) => params.append('agentIds[]', id));

  return params;
};

export const fetchAdminStats = async (filters: AdminStatsFilters): Promise<AdminStatsResponse> => {
  const params = serializeFilters(filters);
  const { data } = await apiClient.get<AdminStatsResponse>('/admin/stats', { params });
  return data;
};

export type { AdminStatsFilters, AdminStatsResponse };
